module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m2-69281469eed01726f8c577bdea3a0972.svg";